// src/components/AnimatedBackground.js
import React, { useRef, useMemo } from "react";
import * as THREE from "three";
import { Canvas, extend, useFrame } from "@react-three/fiber";
import { Center, shaderMaterial, Plane } from "@react-three/drei";
import { vertexShader, fragmentShader } from "../shader";
import { useStyle } from "../context/StyleContext";

const NoiseMaterial = shaderMaterial(
  {
    scale: 10,
    size: 0.6,
    density: 5.0,
    time: 0.0,
    bg: new THREE.Color("#111033"),
    yellow: new THREE.Color("#ffd600"),
    orange: new THREE.Color("#ff7300"),
  },
  vertexShader,
  fragmentShader
);

extend({ NoiseMaterial });

function Data({ scale, size, density, speed, bg, lineColor }) {
  const material = useRef();

  const bgColor = useMemo(() => new THREE.Color(bg), [bg]);
  const lineColorValue = useMemo(() => new THREE.Color(lineColor), [lineColor]);

  useFrame(({ clock }) => {
    if (material.current) {
      material.current.uniforms.time.value = clock.getElapsedTime() * speed;
    }
  });

  return (
    <Plane args={[100, 100]}>
      <noiseMaterial
        ref={material}
        side={THREE.DoubleSide}
        scale={scale}
        size={size}
        density={density}
        bg={bgColor}
        yellow={lineColorValue}
        orange={lineColorValue}
      />
    </Plane>
  );
}

export default function AnimatedBackground() {
  const styles = useStyle();

  return (
    <Canvas
      dpr={[1, 1.5]}
      camera={{ position: [0, 0, 10], far: 100 }}
      className="fixed top-0 left-0 w-full h-full -z-10"
    >
      <Center>
        <Data
          scale={10}
          size={0.1}
          density={6}
          speed={0.003}
          bg={styles.backgroundColor}
          lineColor={styles.lineColor}
        />
      </Center>
    </Canvas>
  );
}
